import { SettingOutlined } from "@ant-design/icons";
import { Tabs } from "antd";
import { useState } from "react";
import TbGroup from "../../../../components/MagaTableV2/tbgroup";
import ContactInformation from "../ServiceRecords/ContactInformation";
import MaintenanceHistory from "../ServiceRecords/MaintenanceHistory";
import VehicleContactHistory from "../ServiceRecords/VehicleContactHistory";
import WarrantyInformation from "../ServiceRecords/WarrantyInformation";

const OwnedCar = ({ stData = {} as any, stChange = (data: any) => { } }) => {
  const tableColumns = (sourceColumnWarehouse: any) => {
    const temp = [] as any
    sourceColumnWarehouse.vehicle_owner?.list.map((col: any) => {
      if (col.field === 'vehicle_type_category' || col.field === 'vehicle_brand') return;
      if (col.field === 'contact_name') {
        temp.push({
          headerName: col.headerName,
          field: col.field,
          cellRenderer: (params: any) => {
            return (
              <div className={params.data.contact_name_id !== 'Không xác định' && params.data.contact_name_id ? 'cus-link-detail' : ''}>
                <a className="color-bage d-none" href={`/customer/pooling-data/customer-list/detail?id_sync=${params.data.contact_name_id}`}>{params.data.contact_name}</a>
                <span className="text">{params.data.contact_name || 'Không xác định'}</span>
              </div>
            )
          },
        });
      } else {
        temp.push({
          headerName: col.headerName,
          field: col.field,
          tooltipField: col.field,
        })
      }
    })
    return temp
  }
  const [megaTableData, setMegaTableData] = useState<any>({
    name: 'TbCacheOwnedCar',
    col: [
      {
        field: "vehicle_type_category",
        headerName: "Hành động",
        width: 300,
        filter: false,
        lockPosition: 'left',
      },
      ...tableColumns(stData.sourceColumnWarehouse),
      // { field: "vehicle_name", headerName: "Tên xe" },
      // { field: "dongxe", headerName: "Dòng xe" },
      // { field: "cus_name", headerName: "Chủ xe" },
      // { field: "contact_name", headerName: "Người đại điện" },
      // { field: "vehicle_chassis_no", headerName: "Số khung" },
      // { field: "color_name", headerName: "Màu xe" },
      // { field: "engine_no", headerName: "Số máy" },
      // { field: "made_year", headerName: "Năm sản xuất" },
      // { field: "number_plate", headerName: "Biển số" },
      // { field: "purchase_date", headerName: "Ngày mua" },
      // { field: "vehicle_model", headerName: "Mẫu xe" },
      // { field: "branch_name", headerName: "Đơn vị" },
      // { field: "route_name", headerName: "Chi nhánh" },
    ],
    listData: stData.xesohuu || [],
    hideRowsSelect: true,
    showSetting: false,
    loading: false,
    defaultColDef: { sortable: false },
    treeField: ["vehicle_type_category", "vehicle_brand"],
    height: '400px',
  });
  const [activeServiceRecordsTab, setActiveServiceRecordsTab] = useState("1");

  return (
    <>
      <div className="setting-tb-has-tab">
        <div className='settingCol'>
          <div className='ctr-col-setting' onClick={() => setMegaTableData((prev: any) => ({ ...prev, showSetting: true }))}>
            <SettingOutlined />
          </div>
        </div>
      </div>
      <TbGroup stData={{ ...megaTableData }} stChange={(data, type) => {
        if (type === 'viewDetail') {
          stChange({ xesohuu_show: data });
        }
        if (type === 'showSetting') {
          setMegaTableData((prev: any) => ({ ...prev, showSetting: data }));
        }
      }} />

      <div
        className="ag-theme-alpine custom-table-ag custom-page-css custom-tabs"
        style={{ width: "100%", marginTop: "16px" }}
      >
        <Tabs
          activeKey={activeServiceRecordsTab}
          items={[
            {
              key: "1",
              label: (
                <span className="custom-page-css font-light text-lg">
                  Thông tin hợp đồng
                </span>
              ),
              children: (
                <ContactInformation
                  stData={stData}
                  stChange={(data, type) => {
                    if (type === 'vehicle_contract') {
                      stChange({ xesohuu_show_vehicle_contract: data });
                    }
                  }}
                />
              ),
            },
            {
              key: "2",
              label: (
                <span className="custom-page-css font-light text-lg">
                  Thông tin bảo hiểm xe
                </span>
              ),
              children: (
                <WarrantyInformation
                  stData={stData}
                  stChange={(data, type) => {
                    if (type === 'vehicle_insurance') {
                      stChange({ xesohuu_show_vehicle_insurance: data });
                    }
                  }}
                />
              ),
            },
            {
              key: "3",
              label: (
                <span className="custom-page-css font-light text-lg">
                  Lịch sử bảo trì bảo dưỡng
                </span>
              ),
              children: (
                <MaintenanceHistory
                  stData={stData}
                  stChange={(data, type) => {
                    if (type === 'vehicle_service_history') {
                      stChange({ xesohuu_show_vehicle_service_history: data });
                    }
                  }}
                />
              ),
            },
            {
              key: "4",
              label: (
                <span className="custom-page-css font-light text-lg">
                  Lịch sử tiếp xúc của xe
                </span>
              ),
              children: (
                <VehicleContactHistory
                  stData={stData}
                  stChange={(data, type) => {
                    if (type === 'vehicle_interaction_history') {
                      stChange({ xesohuu_show_vehicle_interaction_history: data });
                    }
                  }}
                />
              ),
            }
          ]}
          onChange={(k) => setActiveServiceRecordsTab(k)}
        />
      </div>
    </>
  );
};
export default OwnedCar;
